
import ButtonHistory from '@/components/button/ButtonHistory.ts';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component
export default class ButtonHistoryRemove extends Mixins(ButtonHistory) {
  @Prop({default: false})
  private isEditMode!: boolean;
}
